<template>
  <div class="item podcast">
    <div class="top">
      <div class="left">
        <div class="icon"></div>
        <div class="title"><span>PodCast</span></div>
      </div>
      <div class="actions">
        <button :disabled="prev <= 0" @click="getPod(prev)"><i class="fa-solid fa-angle-left"></i></button>
        <button :disabled="next === 0" @click="getPod(next)"><i class="fa-solid fa-angle-right"></i></button>
      </div>
    </div>
    <div class="content">
      <div v-if="loading" class="w-full h-full flex flex-col gap-2 p-3">
        <Sk w="100%" h="180px" rounded="rounded-xl" />
        <Sk w="60%" h="14px" />
        <Sk w="80%" h="12px" />
      </div>
      <div class="box" v-for="p in pod" :key="p.id" :style="{backgroundImage: 'url('+p.imagem+')'}"
           v-show="!loading && pod.length > 0">
        <div class="data">
          <div class="info">
            <div class="span">
              <span class="nobr">{{ p.title }}</span><br>
              <span>{{ p.description }}</span>
            </div>
            <div class="play"><i @click="getPlay(p.audio, !playing, $event)" class="fa-solid fa-play"></i></div>
          </div>
        </div>
        <audio controls id="podcast" hidden></audio>
      </div>
    </div>
  </div>
</template>

<script setup>

import { getPodcast } from '@/services/api.js'
import Sk from '@/components/usefulness/Sk.vue'
import { onMounted, ref } from 'vue'

const pod = ref([])
const loading = ref(true)
const prev = ref(0)
const next = ref(0)
const total = ref(0)
const disabledP = ref(true)
const disabledN = ref(true)
const playing = ref(false)

async function getPod(pag = 1) {
  loading.value = true
  try {
    const data = await getPodcast({ pag })
    pod.value   = data.podcast
    prev.value  = data.prev
    next.value  = data.next
    total.value = data.total
    disabledP.value = parseInt(data.prev) === 0
    disabledN.value = data.next === 0
  } catch {
    pod.value = []
  } finally {
    loading.value = false
  }
}

function getPlay(a, p, e) {

  let idAudio = document.getElementById('podcast')

  if (idAudio.childNodes[0] == null) {
    idAudio.innerHTML = `<source src="${a}" type="audio/mpeg">`
    idAudio.play()

    let icon = e.target
    icon.classList.remove('fa-play')
    icon.classList.add('fa-pause')
  } else {
    let icon = e.target
    playing.value = !playing.value
    if (p) {
      icon.classList.remove('fa-pause')
      icon.classList.add('fa-play')
      idAudio.pause()
    } else {
      icon.classList.remove('fa-play')
      icon.classList.add('fa-pause')
      idAudio.play()
    }
  }

}

onMounted(() => getPod())

</script>

<style scoped>
.podcast {
  width: 100%;
  height: 330px;
  @apply max-w-[535px] xl:w-full;
}

.podcast .top .icon {
  background-position: -34px 4px;
  background-color: #101D27;
}

.podcast .content {
  float: left;
  width: 100%;
  height: 280px;
  background-color: #fff;
  border-radius: 12px;
  padding: 10px;
  overflow: hidden;
}

.podcast .box {
  float: left;
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 12px;
}

.podcast .box .data {
  float: left;
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  background-color: rgba(255, 255, 255, .82);
  margin: 1px;
  border-radius: 12px;
  opacity: 0;
  visibility: hidden;
  transition: all .4s ease;
}

.podcast .box:hover .data {
  opacity: 1;
  visibility: visible;
}

.podcast .box .data > div {
  margin-top: 180px;
  float: left;
  width: 100%;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
}

.podcast .box .data > div .span {
  float: left;
  width: calc(100% - 70px);
}

.podcast .box .data > div .span span {
  font-size: 14px;
}

.podcast .box .data > div .span span:first-of-type {
  font-weight: 600;
}

.podcast .box .data > div .span span:last-of-type {
  height: 37px;
  overflow: hidden;
}

.podcast .box .data > div .play {
  width: 60px;
  height: 60px;
  float: left;
  margin-left: 10px;
  background-color: #2BAB3E;
  border-radius: 60px;
  color: #fff;
  line-height: 62px;
  text-align: center;
  cursor: pointer;
}

.podcast .box .data > div .play i {
  width: 100%;
  height: 100%;
}
</style>
